import React from "react";
import './project.scss'
import Input from "../input/input";
let self;

export class Project extends React.Component<any, any> {
    projectForm = { clientName: '', description: '', technologies: [] };
    constructor(props: any) {
        super(props);
        self = this;
        this.state = { projectForm: this.projectForm, noOfTechnologies: 0, technologies: {} }
        // this.send = this.send.bind(this);
    }

    send(event, isNext) {
        event.preventDefault();
        const projectData = {
            ...this.state.projectForm,
            technologies: Object.values(self.state.technologies)
        }
        self.props.onProjectAdded(projectData, isNext)
    }

    onInputChange(data, field) {
        self.setState((prevState) => ({
            projectForm: { ...prevState.projectForm, [field]: data }
        }))
    }
    onNoOfTechnologiesChange(data, field) {
        self.setState({ noOfTechnologies: data });
        // console.log(self.state)
    }

    onTechnologyChanges(data, field) {
        self.setState((prevState) => ({
            technologies: { ...prevState.technologies, [field]: data }
        }))
    }

    render(): React.ReactNode {
        return (
            <div className="form__wrapper">
                <h4>Enter Project {this.props.projectNo}</h4>
                <form className="form__item">
                    <Input placeHolder='Enter Client Name' type='text' key={1} value="" maxLength="100" minLength="1" name="clientName" onInputChange={this.onInputChange}></Input>
                    <Input placeHolder='Enter Project Description' type='text' key={2} value="" maxLength="100" minLength="1" name="description" onInputChange={this.onInputChange}></Input>
                    {(!this.state.noOfTechnologies) ?
                        <Input placeHolder='How many Technologies you want to add ?' type='tel' key={0} value="" maxLength="1" minLength="1" onInputChange={this.onNoOfTechnologiesChange}></Input>
                        :
                        <>
                            {Array.from({ length: this.state.noOfTechnologies }).map((e, i) => {
                                return <Input placeHolder={`Enter Technology ${i + 1}`} type='text' name={`technology${i + 1}`} key={i} value="" onInputChange={this.onTechnologyChanges}></Input>
                            })}
                        </>
                    }
                    {
                        this.state.noOfTechnologies>0 &&
                        <>
                        <button className="app-btn" onClick={(e)=> this.send(e,false)}>Done?</button>
                        <button className="app-btn" onClick={(e)=> this.send(e,true)}>Want to Add more Project ?</button>
                        </>
                    }
                </form>
            </div>
        )
    }
}

export default Project;